import { render, staticRenderFns } from "./quickmenu.vue?vue&type=template&id=36d70d8d&"
import script from "./quickmenu.vue?vue&type=script&lang=js&"
export * from "./quickmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports